import { render } from "./ReadingAnswer.vue?vue&type=template&id=3367e4b6&scoped=true&ts=true"
import script from "./ReadingAnswer.vue?vue&type=script&lang=ts"
export * from "./ReadingAnswer.vue?vue&type=script&lang=ts"

import "./ReadingAnswer.vue?vue&type=style&index=0&id=3367e4b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3367e4b6"]])

export default __exports__